import { createFileRoute } from '@tanstack/react-router';
import OnboardingTerms from '@/features/account/onboarding/terms';

export const Route = createFileRoute('/onboarding/termos')({
  component: OnboardingTerms,
});
